let supportPageOffset = window.pageXOffset !== undefined;
let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');

export function getElementOffset(anchor: HTMLElement) {
  let offset = 0;
  let el = anchor;
  if (anchor && anchor.offsetParent) {
    do {
      offset += el.offsetTop;
      el = el.offsetParent as HTMLElement;
    } while (el);
  }
  return Math.max(offset, 0);
}

function isNode(o: any): o is Node {
  return typeof Node === 'object'
    ? o instanceof Node
    : o && typeof o === 'object' && typeof o.nodeType === 'number' && typeof o.nodeName === 'string';
}

export function currentOffset() {
  if (supportPageOffset) return window.pageYOffset;
  if (isCSS1Compat) return document.documentElement.scrollTop;
  return document.body.scrollTop;
}

export function scrollTo(offset: number | HTMLElement, margin = 0) {
  if (isNode(offset)) {
    scrollTo(getElementOffset(offset), margin);
    return;
  }
  if (currentOffset() <= offset) return;
  let topOffset = offset + 6 - margin;
  window.scrollTo(0, topOffset);

  function closer() {
    window.scrollTo(0, topOffset);
    topOffset -= 1;
    if (topOffset >= (offset as number) - margin) setTimeout(() => requestAnimationFrame(closer), 0);
  }

  closer();
}

export function scrollToTop() {
  scrollTo(0);
}
